import React from "react";

function SbCardView({ card, size = "md", playable = false, selected = false, onClick, testId, faceDown = false, skin = "sb_classic" }) {
  if (!card && !faceDown) return null;
  const sizeCls = size === "sm" ? "sb-card-sm" : size === "xs" ? "sb-card-xs" : size === "lg" ? "sb-card-lg" : size === "md-lg" ? "sb-card-md" : "";
  const skinCls = `sb-skin-${skin}`;
  if (faceDown) {
    return (
      <div className={`sb-card sb-card-back ${skinCls} ${sizeCls}`} data-testid={testId}>
        <div className="sb-card-inner">DOS</div>
      </div>
    );
  }
  const label = card.value === "skipbo" ? "SB" : String(card.value);
  const kind = card.value === "skipbo" ? "wild" : "num";
  return (
    <div
      data-testid={testId}
      className={`sb-card sb-card-${kind} ${skinCls} ${sizeCls} ${playable ? "playable" : ""} ${selected ? "selected" : ""}`}
      onClick={playable ? onClick : undefined}
      role={playable ? "button" : undefined}
    >
      <div className="sb-card-corner tl">{label}</div>
      <div className="sb-card-inner">{label}</div>
      <div className="sb-card-corner br">{label}</div>
    </div>
  );
}

export default SbCardView;
